"use strict";
/* eslint-disable max-lines */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltStaffFeedback = void 0;
const variables_1 = require("@whispir/variables");
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Staff Feedback',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '1d1894bf-5519-46a0-bf0f-c5b6fcc239f4',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/StaffFeedback.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35',
            data: {
                backgroundColor: '#ffffff',
                label: 'Name',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '88f81914-c251-4cec-968a-f1a2dd0d1a1d',
            data: {
                backgroundColor: '#ffffff',
                label: 'Email Address',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'email',
            },
        },
        {
            type: 'form-dropdown',
            version: '1',
            id: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
            data: {
                backgroundColor: '#FFFFFF',
                label: 'Department',
                requiredField: false,
                helperText: '',
                options: [
                    {
                        id: 'b9556b95-b23d-40d5-b842-2eadb6929f20',
                        label: 'Customer Support',
                        value: false,
                    },
                    {
                        id: 'cf5cc518-66bf-4b33-976b-6ae686bf069d',
                        label: 'Sales',
                        value: false,
                    },
                    {
                        id: '753f9ed0-8cd1-4c37-b94e-ad30be4c76dd',
                        label: 'Marketing',
                        value: false,
                    },
                    {
                        id: 'ac562d7a-3025-4aa2-b891-b570807d7806',
                        label: 'Development',
                        value: false,
                    },
                    {
                        id: '6add93e2-0c63-4e3c-8ae4-546e8c4d1741',
                        label: 'Finance',
                        value: false,
                    },
                ],
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'd3f33821-0794-4f92-ae68-4cc418a21526',
            data: {
                backgroundColor: '#ffffff',
                requiredField: true,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Feedback Type',
                options: [
                    {
                        label: 'Positive',
                        id: 'fbbe01a7-d0ea-4d0e-aeaa-daeb1a8a567c',
                        value: false,
                    },
                    {
                        label: 'Negative',
                        id: '27666d2b-e289-4ca9-8bcf-9a69f06e573b',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: 'a482fc86-fcf2-428e-b298-00f7b282883c',
            data: {
                backgroundColor: '#ffffff',
                label: 'Feedback',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-checkbox-list',
            version: '1',
            id: '22517ef3-dc5f-4ba9-8920-a83ff06a9b6d',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Follow up',
                options: [
                    {
                        label: 'I would like to be contacted to discuss my feedback further',
                        id: '2c917d46-bb56-4414-b107-3cae3d240aed',
                        value: true,
                    },
                ],
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: 'e87c43f6-70d8-432f-aff6-a637f91b1efe',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#1515FF',
                borderRadius: 4,
                buttonColor: '#1515FF',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Submit Feedback',
                textAlign: 'center',
                width: 600,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: '1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Name',
        },
        {
            id: '88f81914-c251-4cec-968a-f1a2dd0d1a1d',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Email Address',
        },
        {
            id: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
            valueType: 'string',
            inputType: 'form-dropdown',
            label: 'Department',
            options: [
                {
                    id: 'b9556b95-b23d-40d5-b842-2eadb6929f20',
                    label: 'Customer Support',
                    value: false,
                },
                {
                    id: 'cf5cc518-66bf-4b33-976b-6ae686bf069d',
                    label: 'Sales',
                    value: false,
                },
                {
                    id: '753f9ed0-8cd1-4c37-b94e-ad30be4c76dd',
                    label: 'Marketing',
                    value: false,
                },
                {
                    id: 'ac562d7a-3025-4aa2-b891-b570807d7806',
                    label: 'Development',
                    value: false,
                },
                {
                    id: '6add93e2-0c63-4e3c-8ae4-546e8c4d1741',
                    label: 'Finance',
                    value: false,
                },
            ],
        },
        {
            id: 'd3f33821-0794-4f92-ae68-4cc418a21526',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'Feedback Type',
            options: [
                {
                    label: 'Positive',
                    id: 'fbbe01a7-d0ea-4d0e-aeaa-daeb1a8a567c',
                    value: false,
                },
                {
                    label: 'Negative',
                    id: '27666d2b-e289-4ca9-8bcf-9a69f06e573b',
                    value: false,
                },
            ],
        },
        {
            id: 'a482fc86-fcf2-428e-b298-00f7b282883c',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Feedback',
        },
        {
            id: '22517ef3-dc5f-4ba9-8920-a83ff06a9b6d',
            valueType: 'array-of-string',
            inputType: 'form-checkbox-list',
            label: 'Follow up',
            options: [
                {
                    label: 'I would like to be contacted to discuss my feedback further',
                    id: '2c917d46-bb56-4414-b107-3cae3d240aed',
                    value: true,
                },
            ],
        },
    ],
};
const copyOfFeedbackEmail = {
    subject: 'Thanks <span data-variableid="step_0__vid_1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35">Name</span>, Here&#x27;s a copy of your feedback!',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'be6ff51c-f6b7-4856-b397-f887124f030e',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/feedback_copy.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'b547aac5-e086-4a16-99ae-90cb38188f78',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="step_0__vid_1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35">Name</span>,</p><p></p><p>Your feedback has been received and passed onto the relevant team manager. Please see a copy of your feedback below!</p><p></p><p><span data-variableid="web_link">Web content link</span></p>',
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const copyOfFeedbackWeb = {
    subject: 'Copy of Feedback',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'ab7deb75-28ac-429f-95e8-2f96c458fb47',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/feedback_copy.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '7fc356aa-13dd-4590-83a7-250ebb145c36',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35">Name</span>,</p><p></p><p>Your feedback has been received and passed onto the relevant team manager. Please see a copy of your feedback below!</p><p></p><p><strong>Feedback type:</strong> <span data-variableid="d3f33821-0794-4f92-ae68-4cc418a21526">Feedback Type</span></p><p> </p><p><strong>Feedback:</strong></p><p></p><p><span data-variableid="a482fc86-fcf2-428e-b298-00f7b282883c">Feedback</span></p><p> </p>',
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
    workspaceId: 'FAA4358B519D0E89',
};
const adminFeedbackEmail = {
    subject: '<span data-variableid="d3f33821-0794-4f92-ae68-4cc418a21526">Feedback Type</span> received from: <span data-variableid="1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35">Name</span>',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'd19b6fb4-ef9f-4128-a6aa-e7cb5cc0cb40',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/feedback_copy.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'c68d7fb6-9a75-405a-b70b-77e6cc31e6ce',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi there!</p><p></p><p><span data-variableid="1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35">Name</span> (<span data-variableid="88f81914-c251-4cec-968a-f1a2dd0d1a1d">Email Address</span>) from <span data-variableid="deb9123d-d41b-4bc2-a5ed-67f160f1b4a3">Department</span> has submitted <span data-variableid="d3f33821-0794-4f92-ae68-4cc418a21526">Feedback Type</span> feedback!</p><p></p><p><strong>Feedback</strong>:</p><p></p><p><span data-variableid="a482fc86-fcf2-428e-b298-00f7b282883c">Feedback</span></p><p> </p><p><strong>Follow up</strong>: <span data-variableid="22517ef3-dc5f-4ba9-8920-a83ff06a9b6d">Follow up</span></p><p> </p>',
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
    workspaceId: 'FAA4358B519D0E89',
};
const prebuiltStaffFeedback = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: 'Name',
                        variableId: '1ccfe0d7-dbc2-47a9-956b-b371a0ed7a35',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Email Address',
                        variableId: '88f81914-c251-4cec-968a-f1a2dd0d1a1d',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Department',
                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Customer Support","checked":"false"},{"id":2,"text":"Sales","checked":"false"},{"id":3,"text":"Marketing","checked":"false"},{"id":"d0d3604a-7567-4a1d-93eb-6191acb0813b","text":"Development","checked":"false"},{"id":"b45b3205-4087-4fb8-b719-1b441ed4183b","text":"Finance","checked":"false"}]',
                        type: 'FormDropdown',
                    },
                    {
                        variableName: 'Feedback Type',
                        variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Positive","checked":"false"},{"id":2,"text":"Negative","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: 'Feedback',
                        variableId: 'a482fc86-fcf2-428e-b298-00f7b282883c',
                        variableType: 'string',
                        type: 'FormTextArea',
                    },
                    {
                        variableName: 'Follow up',
                        variableId: '22517ef3-dc5f-4ba9-8920-a83ff06a9b6d',
                        variableType: 'string',
                        options: '[{"id":1,"text":"I would like to be contacted to discuss my feedback further","checked":"true"}]',
                        type: 'FormCheckboxList',
                    },
                ],
            },
            type: 'start',
            next: [
                {
                    id: 3890,
                    variables: {
                        input: [],
                        output: [],
                    },
                    type: 'task',
                    action: 'send-email',
                    next: [
                        {
                            id: 950,
                            type: 'condition',
                            next: [
                                {
                                    id: 7886,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 7386,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Customer Support - Positive',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'c0d89bec-c145-4459-9d77-71d68963cc92',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Positive',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 6641,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 8008,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Customer Support - Negative',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '7cd5a8be-926a-4ac8-b915-2c7fcfb0b557',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Negative',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                            ],
                            action: 'expression',
                            isDirty: true,
                            variables: {
                                input: [],
                                output: [],
                            },
                            version: '1.0.1',
                            data: {
                                stepName: 'IF Condition',
                                expression: {
                                    id: 'a30c39a7-3d19-4b3e-b8bf-aa3cd1ea2c29',
                                    type: 'expression',
                                    operator: 'equals',
                                    right: {
                                        type: 'constant',
                                        value: 'Customer Support',
                                        valueType: 'string',
                                    },
                                    left: {
                                        type: 'variable',
                                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                                        stepId: '0',
                                    },
                                },
                            },
                        },
                        {
                            id: 2092,
                            type: 'condition',
                            next: [
                                {
                                    id: 6826,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 584,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Sales - Positive',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '347ac6b0-7534-48f7-bc10-6477cdfa269c',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Positive',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 1353,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 4830,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Sales - Negative',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'e606f2fd-aa7d-47e8-86f8-ba73ecb19cd2',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Negative',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                            ],
                            action: 'expression',
                            isDirty: true,
                            variables: {
                                input: [],
                                output: [],
                            },
                            version: '1.0.1',
                            data: {
                                stepName: 'IF Condition',
                                expression: {
                                    id: '3a7b4810-0c75-4955-b2cc-f195ec63686a',
                                    type: 'expression',
                                    operator: 'equals',
                                    right: {
                                        type: 'constant',
                                        value: 'Sales',
                                        valueType: 'string',
                                    },
                                    left: {
                                        type: 'variable',
                                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                                        stepId: '0',
                                    },
                                },
                            },
                        },
                        {
                            id: 5132,
                            type: 'condition',
                            next: [
                                {
                                    id: 2329,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 5768,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-email',
                                            next: null,
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Marketing - Positive',
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '91997e57-8d14-4f7b-875a-91e8fed1d688',
                                            type: 'expression',
                                            operator: 'or',
                                            operands: [
                                                {
                                                    id: '81810daa-2238-44b9-93f3-afa0e5fdce73',
                                                    type: 'expression',
                                                    operator: 'equals',
                                                    right: {
                                                        type: 'constant',
                                                        value: 'Positive',
                                                        valueType: 'string',
                                                    },
                                                    left: {
                                                        type: 'variable',
                                                        variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                        stepId: '0',
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                },
                                {
                                    id: 4640,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 2827,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-email',
                                            next: null,
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Marketing - Negative',
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'f0486f01-783d-4a13-9436-7fe3d65b429e',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Negative',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                            ],
                            action: 'expression',
                            isDirty: true,
                            variables: {
                                input: [],
                                output: [],
                            },
                            version: '1.0.1',
                            data: {
                                stepName: 'IF Condition',
                                expression: {
                                    id: 'ab64eeda-1b21-4e70-af77-00acecafbc32',
                                    type: 'expression',
                                    operator: 'equals',
                                    right: {
                                        type: 'constant',
                                        value: 'Marketing',
                                        valueType: 'string',
                                    },
                                    left: {
                                        type: 'variable',
                                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                                        stepId: '0',
                                    },
                                },
                            },
                        },
                        {
                            id: 2161,
                            type: 'condition',
                            next: [
                                {
                                    id: 120,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 1821,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-email',
                                            next: null,
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Development - Positive',
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '1a57bae0-1c0a-4888-93a6-a5f70682ce72',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Positive',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 6742,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 9317,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-email',
                                            next: null,
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Development - Negative',
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '0a62696d-5913-4b1e-9312-5f2fa96c00af',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Negative',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                            ],
                            action: 'expression',
                            isDirty: true,
                            variables: {
                                input: [],
                                output: [],
                            },
                            version: '1.0.1',
                            data: {
                                stepName: 'IF Condition',
                                expression: {
                                    id: '0510a11f-5a90-4aeb-8732-bca95bc5385d',
                                    type: 'expression',
                                    operator: 'equals',
                                    right: {
                                        type: 'constant',
                                        value: 'Development',
                                        valueType: 'string',
                                    },
                                    left: {
                                        type: 'variable',
                                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                                        stepId: '0',
                                    },
                                },
                            },
                        },
                        {
                            id: 5745,
                            type: 'condition',
                            next: [
                                {
                                    id: 7056,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 6891,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Finance - Positive',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'cbc7da31-9e68-4ec3-b400-1a81f37182df',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Positive',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 9372,
                                    type: 'condition',
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: [
                                        {
                                            id: 955,
                                            type: 'task',
                                            next: null,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            action: 'send-email',
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, adminFeedbackEmail), { workspaceId })); }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'Finance - Negative',
                                            },
                                        },
                                    ],
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '65955f2e-9dce-4ec6-b248-b758a975ab0d',
                                            type: 'expression',
                                            operator: 'equals',
                                            right: {
                                                type: 'constant',
                                                value: 'Negative',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: 'd3f33821-0794-4f92-ae68-4cc418a21526',
                                                stepId: '0',
                                            },
                                        },
                                    },
                                },
                            ],
                            action: 'expression',
                            isDirty: true,
                            variables: {
                                input: [],
                                output: [],
                            },
                            version: '1.0.1',
                            data: {
                                stepName: 'IF Condition',
                                expression: {
                                    id: 'b888d380-b83a-43d7-89b0-3299323f71d8',
                                    type: 'expression',
                                    operator: 'equals',
                                    right: {
                                        type: 'constant',
                                        value: 'Finance',
                                        valueType: 'string',
                                    },
                                    left: {
                                        type: 'variable',
                                        variableId: 'deb9123d-d41b-4bc2-a5ed-67f160f1b4a3',
                                        stepId: '0',
                                    },
                                },
                            },
                        },
                    ],
                    isDirty: true,
                    version: '1.0.4',
                    data: {
                        workspaceId,
                        recipients: [
                            {
                                type: 'variable',
                                stepId: '0',
                                variableId: '88f81914-c251-4cec-968a-f1a2dd0d1a1d',
                            },
                        ],
                        message: {
                            content: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, copyOfFeedbackEmail), { workspaceId })); }),
                            }),
                            type: 'email',
                        },
                        link: {
                            type: 'web',
                            content: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, copyOfFeedbackWeb), { workspaceId })); }),
                            }),
                        },
                        collectResponses: false,
                        stepName: 'Copy of Feedback',
                    },
                },
            ],
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltStaffFeedback = prebuiltStaffFeedback;
//# sourceMappingURL=staffFeedback.js.map